import { useApiPrivateRequest } from "../../../shared/hooks/useApi";
import { UserDocumentChunk } from "../models/UserDocumentChunk";

export const useGetDocumentSource = () => {
  const {
    data: source,
    call,
    isLoading,
    isFailed,
  } = useApiPrivateRequest<UserDocumentChunk>(
    (response) => new UserDocumentChunk(response),
  );
  const getDocumentSource = async (documentId: string, chunkId?: number) => {
    await call(`documents/${documentId}/source`, "GET", {
      chunkId,
    });
  };

  return { source, getDocumentSource, isLoading, isFailed };
};
